import { Outlet } from "react-router";

export const LandingLayout = () => {
  return <Outlet />;
};
